import { z } from 'zod';

export const classOverrideSchema = z.enum([
  'None',
  'FiftyThreeFootDeprecated',
  'NationaNetworkDeprecated',
  'NationalNetwork',
]);

export type ClassOverride = z.infer<typeof classOverrideSchema>;
